import script from "./CKEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CKEditor.vue?vue&type=script&setup=true&lang=js"

import "./CKEditor.vue?vue&type=style&index=0&id=52a54258&lang=css"

const __exports__ = script;

export default __exports__